module.exports = __webpack_public_path__ + "static/media/logo-min.3e40c5fa.svg";